import React from 'react';
import { Typography, Box } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { DamageWaiverTable } from 'views/common/components';
import Typography500 from 'views/common/components/UI/Typography500';
import {
  StyledBox,
  StyledLightBulbHint,
} from 'views/information-module/InsuranceView/components/CoveringMotorcycle/CoveringMotorcycle.styles';

const CoveringMotorcycle = () => {
  const { t } = useTranslation('fe_er_insurance_page');
  return (
    <StyledBox>
      <Typography500 component="h3" variant="h3">
        {t('fe_er_insurance_page:covering_motorcycle_header')}
      </Typography500>

      <Typography
        component="p"
        variant="body1"
        dangerouslySetInnerHTML={{
          __html: t('fe_er_insurance_page:covering_motorcycle_description'),
        }}
      />
      <StyledLightBulbHint>
        <Typography
          variant="h6"
          dangerouslySetInnerHTML={{
            __html: t('fe_er_insurance_page:covering_motorcycle_pricing_note'),
          }}
        />
      </StyledLightBulbHint>
      <Box mb={2}>
        <DamageWaiverTable />
      </Box>

      <Typography
        mb={1.2}
        component="p"
        variant="body1"
        dangerouslySetInnerHTML={{
          __html: t('fe_er_insurance_page:security_deposit_details'),
        }}
      />

      <Typography
        mb={3.5}
        component="p"
        variant="body1"
        dangerouslySetInnerHTML={{
          __html: t(
            'fe_er_insurance_page:available_at_participating_locations',
          ),
        }}
      />

      <Typography500 component="h4" variant="h4">
        {t('fe_er_insurance_page:personal_property_coverage')}
      </Typography500>

      <Typography
        mb={2}
        component="p"
        variant="h6"
        className="CMParagraph"
        dangerouslySetInnerHTML={{
          __html: t('fe_er_insurance_page:personal_property_coverage_overview'),
        }}
      />
    </StyledBox>
  );
};

export { CoveringMotorcycle };
